import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { Venue, VenueDetailResponse, VenueListResponse } from 'src/app/models/venue.model';
import { map } from 'rxjs/operators';
import { get, patch } from 'aws-amplify/api';


@Injectable({
  providedIn: 'root'
})
export class VenueService {
  getVenues(): Observable<VenueListResponse> {
    const op = get({
      apiName: 'portal',
      path: 'venues',
    });
    return from(op.response.then(async (r) => (await r.body.json()) as any)).pipe(
      map((venueList: any) => {
        const isPartialVenueList = venueList.isComplete;
        const venueDetails = venueList.data?.map(({ id, name, shortDesc, location }) => ({
          venueId: id,
          venueName: name,
          shortDesc,
          location,
          isComplete: isPartialVenueList,
        }));
        return { venus: venueDetails } as VenueListResponse;
      })
    );
  }
  getVenueById(venueId: string): Observable<VenueDetailResponse> {
    const op = get({
      apiName: 'portal',
      path: 'venues',
      options: {
        queryParams: { id: venueId },
      },
    });
    return from(op.response.then(async (r) => (await r.body.json()) as any)).pipe(
      map((details: any) => {
        const original = details?.data?.[0];
        const isPartialVenueList = details?.isComplete;
        const mapped = original
          ? {
              venueId: original.id,
              venueName: original.name,
              shortDesc: original.shortDesc,
              longDesc: original.longDesc,
              location: original.location,
              key: original.key,
              menuTitle: original.menuTitle,
              links: original.menuLink,
              menuAlertMessage: original.menuAlertMessage,
              hours: original.hours,
              isComplete: isPartialVenueList,
            }
          : null;
        return { venus: mapped ? [mapped] : [] } as VenueDetailResponse;
      })
    );
  }
  updateVenue(venue: Venue): Observable<any> {
    const venuePayload = {
      ...venue,
      id: venue.venueId,
      name: venue.venueName,
      menuLink: venue.links,
    };
  
    const safeBody = JSON.parse(JSON.stringify(venuePayload));
    const op = patch({
      apiName: 'portal',
      path: 'venues',
      options: {
        queryParams: { id: venue.venueId },
        body: safeBody,
      },
    });
    return from(op.response.then(async (r) => (await r.body) as any));
  }
}